// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { i18n } from '../../index'
import css from './checklistDialog.css'
import ChecklistForm from './ChecklistForm'
import type { ChecklistItem } from './checklistTypes'
type Props = {
  data: ChecklistItem | null | undefined
  isOpen: boolean
  onClose: (...args: Array<any>) => any
  stationId: string
  refetch: any
}

class ChecklistDialog extends React.Component<Props> {
  render() {
    const { data, stationId, isOpen, onClose, refetch } = this.props
    return (
      <Dialog open={isOpen} onClose={onClose} aria-labelledby='form-dialog-title' className={css.component}>
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.checklists.updateDialogTitle')
            : i18n.t('admin.checklists.createDialogTitle')}
        </DialogTitle>
        <DialogContent>
          <ChecklistForm data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} refetch={refetch} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default ChecklistDialog
